// Copyright (c) 2016 Deere & Company

import {
    resetRegistrationReports,
    sortRegistrationReports
} from './sort-registration-report';
import {
    selectAllDealersOnLoad,
    selectAllRegistrationsReviewDealers,
    selectRegistrationsReviewDealer
} from './select-dealer';
import {selectAllRegistrationStatuses, selectRegistrationStatus} from './select-registration-status';
import {createRegistrationsReviewReport} from './create-reports';
import {readRegistrationStatuses} from './read-registration-statuses';
import {resetCriteria} from './criteria';
import {sharedActionCreators} from '../../shared/action-creators';
import {updateDeliveryDate} from './update-delivery-date';
import {updateRegistrationDate} from './update-registration-date';

export default {
    createRegistrationsReviewReport,
    readRegistrationStatuses,
    resetCriteria,
    resetRegistrationReports,
    selectAllDealersOnLoad,
    selectAllRegistrationStatuses,
    selectAllRegistrationsReviewDealers,
    selectRegistrationStatus,
    selectRegistrationsReviewDealer,
    sortRegistrationReports,
    updateDeliveryDate,
    updateRegistrationDate,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/registrations-review/action-creators/index.js